import { useEffect } from 'react';

export function useCockpitPolling({
  enabled,
  intervalMs,
  onPoll,
}: {
  enabled: boolean;
  intervalMs: number;
  onPoll: () => void;
}): void {
  useEffect(() => {
    if (!enabled) return undefined;
    const interval = window.setInterval(() => {
      if (document.visibilityState === 'visible') onPoll();
    }, intervalMs);
    return () => window.clearInterval(interval);
  }, [enabled, intervalMs, onPoll]);
}
